import React from "react";
import { motion } from "framer-motion";

/**
 * Section-level scroll reveal — subtle fade + upward translation.
 */
export default function Reveal({
  children,
  delay = 0,
  y = 32,
  className = "",
  as = "div",
  once = true,
}) {
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay }}
    >
      {children}
    </Tag>
  );
}
